module.exports = __webpack_public_path__ + "static/media/DSC01501.ca27220b.jpg";